import httpClient from '../config/httpClient';
import firebase from '../config/firebase.config';
import { subscribeToIntegrationStatus } from './integrationImport';

export const subscribeToTaskSource = (companyId, onUpdate) => {
  return firebase
    .firestore()
    .collection('companyDatabase')
    .doc(companyId)
    .onSnapshot(
      (doc) => onUpdate(doc.data()?.isPrimaryTaskSource || 'prodaff'),
      (err) => {
        console.error('Task source listener error:', err);
        onUpdate('prodaff');
      }
    );
};

export const getJiraAuthUrl = async (companyId, userId) => {
  const { data } = await httpClient.post('/jiraGetAuthUrl', {
    companyId,
    userId,
  });
  return data;
};

export const disconnectJira = async (companyId, userId) => {
  const { data } = await httpClient.post('/jiraDisconnect', {
    companyId,
    userId,
  });
  return data;
};

export const getJiraProjects = async (companyId) => {
  const { data } = await httpClient.post('/jiraGetProjects', { companyId });
  return data;
};

export const saveJiraSelectedProjects = async (companyId, projects) => {
  const { data } = await httpClient.post('/jiraSaveSelectedProjects', {
    companyId,
    projects,
  });
  return data;
};

export const importJiraTasks = async (companyId) => {
  const { data } = await httpClient.post('/jiraImportTasks', { companyId });
  return data;
};

const DISCONNECTED_JIRA_STATUS = {
  connected: false,
  cloudId: null,
  siteName: null,
  siteUrl: null,
  selectedProjects: [],
  importStatus: null,
  lastImportAt: null,
  lastImportStats: null,
  connectedAt: null,
  connectedBy: null,
};

export const subscribeToJiraStatus = (companyId, onUpdate) => {
  return subscribeToIntegrationStatus(
    companyId,
    'jira',
    ({ exists, data: d }) => {
      if (!exists || !d.connected) {
        onUpdate(DISCONNECTED_JIRA_STATUS);
        return;
      }
      onUpdate({
        connected: true,
        cloudId: d.cloudId || null,
        siteName: d.siteName || null,
        siteUrl: d.siteUrl || null,
        selectedProjects: d.selectedProjects || [],
        importStatus: d.importStatus || null,
        lastImportAt: d.lastImportAt ? new Date(d.lastImportAt) : null,
        lastImportStats: d.lastImportStats || null,
        connectedAt: d.connectedAt ? new Date(d.connectedAt) : null,
        connectedBy: d.connectedBy || null,
      });
    }
  );
};
